import { render } from "./PopularShareTransactions.vue?vue&type=template&id=7ad0ac1c&scoped=true&ts=true"
import script from "./PopularShareTransactions.vue?vue&type=script&lang=ts"
export * from "./PopularShareTransactions.vue?vue&type=script&lang=ts"

import "./PopularShareTransactions.vue?vue&type=style&index=0&id=7ad0ac1c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ad0ac1c"]])

export default __exports__